<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>用户管理</span>
      <div>
        <el-button type="primary" size="mini" @click="openCreate">新增用户</el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.username"
        placeholder="请输入用户名搜索"
        clearable
        style="width: 260px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="userId" label="编号" width="90" />
      <el-table-column prop="username" label="用户名" min-width="160" />
      <el-table-column prop="email" label="邮箱" min-width="220">
        <template slot-scope="{ row }">
          {{ row.email || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="roleName" label="角色" min-width="150">
        <template slot-scope="{ row }">
          {{ row.roleName || '未分配' }}
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="{ row }">
          {{ row.status === 1 ? '正常' : '禁用' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="330" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            v-if="$hasPermission('sys:user:update', 'sys:user:list')"
            size="mini"
            @click="openEdit(row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="$hasPermission('sys:user:update', 'sys:user:list')"
            size="mini"
            type="warning"
            @click="resetPassword(row)"
          >
            重置密码
          </el-button>
          <el-button
            v-if="$hasPermission('sys:user:role', 'sys:user:list')"
            size="mini"
            @click="openRole(row)"
          >
            分配角色
          </el-button>
          <el-button
            v-if="$hasPermission('sys:user:delete', 'sys:user:list')"
            size="mini"
            type="danger"
            @click="remove(row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.userId ? '编辑用户' : '新增用户'" :visible.sync="createVisible">
      <el-form ref="userForm" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model.trim="form.username" />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="form.email" placeholder="新增或重置密码时用于接收随机密码" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" style="width: 100%">
            <el-option :value="1" label="正常" />
            <el-option :value="0" label="禁用" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.userId ? 'sys:user:update' : 'sys:user:save', 'sys:user:list')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>

    <el-dialog title="分配角色" :visible.sync="roleVisible">
      <el-select v-model="selectedRoleId" placeholder="请选择角色" style="width: 100%">
        <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId" />
      </el-select>
      <span slot="footer">
        <el-button @click="roleVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission('sys:user:role', 'sys:user:list')"
          type="primary"
          @click="saveRole"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    username: ''
  }
}

function defaultForm () {
  return {
    userId: null,
    username: '',
    email: '',
    status: 1
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      roleList: [],
      createVisible: false,
      roleVisible: false,
      currentUserId: null,
      selectedRoleId: null,
      form: defaultForm(),
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: ['blur', 'change'] }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created () {
    this.load()
    this.loadRoles()
  },
  methods: {
    async load () {
      const { data } = await http.get('/sys/user/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    async loadRoles () {
      const { data } = await http.get('/sys/role/options')
      this.roleList = data.data || []
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.createVisible = true
      this.$nextTick(() => {
        this.$refs.userForm && this.$refs.userForm.clearValidate()
      })
    },
    openEdit (row) {
      this.form = {
        userId: row.userId,
        username: row.username,
        email: row.email || '',
        status: row.status
      }
      this.createVisible = true
      this.$nextTick(() => {
        this.$refs.userForm && this.$refs.userForm.clearValidate()
      })
    },
    save () {
      this.$refs.userForm.validate(async valid => {
        if (!valid) return
        const url = this.form.userId ? '/sys/user/update' : '/sys/user/save'
        const { data } = await http.post(url, this.form)
        if (data.code === 0) {
          this.$message.success(this.form.userId ? '用户修改成功' : '用户新增成功，随机密码已发送至邮箱')
          this.createVisible = false
          this.load()
        }
      })
    },
    resetPassword (row) {
      this.$confirm(`确定重置用户“${row.username}”的密码并发送到 ${row.email || '邮箱'} 吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post(`/sys/user/reset-password/${row.userId}`)
        if (data.code === 0) {
          this.$message.success('随机密码已发送至用户邮箱')
        }
      })
    },
    remove (row) {
      this.$confirm('确定删除该用户吗？', '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/sys/user/delete', [row.userId])
        if (data.code === 0) {
          this.$message.success('用户删除成功')
          this.load()
        }
      })
    },
    async openRole (row) {
      this.currentUserId = row.userId
      const { data } = await http.get(`/sys/user/role/${row.userId}`)
      const selected = (data.data || [])[0]
      this.selectedRoleId = selected ? selected.roleId : null
      this.roleVisible = true
    },
    async saveRole () {
      if (!this.selectedRoleId) {
        this.$message.warning('请选择角色')
        return
      }
      const { data } = await http.post(`/sys/user/role/${this.currentUserId}`, { roleId: this.selectedRoleId })
      if (data.code === 0) {
        this.$message.success('角色分配成功')
        this.roleVisible = false
        this.load()
      }
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
